import { render, staticRenderFns } from "./ModifySplit.vue?vue&type=template&id=6a2e9a2c&scoped=true"
import script from "./ModifySplit.vue?vue&type=script&lang=ts"
export * from "./ModifySplit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2e9a2c",
  null
  
)

export default component.exports